import { DEV_BASE_URL, BASE_URL } from "../lib/constants";
import myAxios from "./myAxios";
const API_URL = process.env.NODE_ENV === "development" ? BASE_URL : BASE_URL
const UserUrl = `${API_URL}/api/user`
const VOTEURL = `${API_URL}/api/vote`


export const login = async (email, password) => {
    const body = { password, email }
   return myAxios.post(`${UserUrl}/login`, body)
}

export const register = async({firstName, lastName, matricNo, level, email, password} ) => {
    const body = { email, password, firstName, lastName, level, matricNo }
   return myAxios.post(`${UserUrl}/signup`, body)
}

export const resetPassword = async (email) => {
    const body = { email }
    return myAxios.post(`${UserUrl}/reset-password`, body)
}

export const removeUser = async (email) => {
    return myAxios.delete(`${UserUrl}/delete?email=${email}`)
}

export const getUserVotes = async (userId) => {
    return myAxios.get(`${VOTEURL}/user?userId=${userId}`)
}

export const getSenateVotes = async (level) => {
    return myAxios.get(`${VOTEURL}/getsenatevotes?level=${level}`)
}

export const getExecutiveVotes = async (position) => {
    return myAxios.get(`${VOTEURL}/getexecutivevotes?position=${position}`)
}

export const addVotes =  (userId,
category,
level="",
position,
name,
voteType
) => {
    const body = {  userId, category, position, name, voteType, level }
    return myAxios.post(`${VOTEURL}/`, body)
}

export const addCandidate = async (name, category, level, position, image ) => {
    const body = { name, category, position, image,level }
    return myAxios.post(`${VOTEURL}/addcandidate`, body)
}

export const getSenateCandidates = async (level) => {
    return await myAxios.get(`${VOTEURL}/getsenatecandidates?level=${level}`)
}

export const getExecutiveCandidates = async (position) => {
    return await myAxios.get(`${VOTEURL}/getexecutivecandidates?position=${position}`)
}
export const removeCandidate = async (name) => {
    return await myAxios.post(`${VOTEURL}/remove/?name=${name}`)
}

export const getAllUsers = async () => {
    return await myAxios.get(`${UserUrl}/`)
}

export const ImageUpload = async (file) => {
    return await myAxios.post(`${VOTEURL}/upload`, {data:file})
}